import React from "react";

export function StepItem({ icon, text }) {
  return (
    <div className="d-flex align-items-center gap-4 d-md-flex flex-md-row flex-column text-md-start text-center">
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: icon,
          }}
        />
      </div>
      <p className="mb-0 text-muted" style={{ fontSize: '16px', lineHeight: '1.5' }}>
        {text}
      </p>
    </div>
  );
}
